import React from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../reducers/rootReducer';
import {
  snackbarSelectors,
  removeSnackbar,
} from '../../../reducers/snackbarSlice';
import Snackbar from './Snackbar';

function SnackbarsContainer() {
  const dispatch = useDispatch();
  const snackbars = useAppSelector(snackbarSelectors.selectSnackbars);
  const { currentUser } = useAppSelector((state) => state.userSession);

  const closedTemporarySnackbars = useAppSelector(
    snackbarSelectors.selectClosedTemporarySnackbars,
  );
  const closedPersistentSnackbars = useAppSelector(
    snackbarSelectors.selectClosedPersistentSnackbars,
  );

  const visibleSnackbars = snackbars.filter((snackbar) => {
    if (
      snackbar.persistencyType === 'temporary' &&
      closedTemporarySnackbars.includes(`${snackbar.id}-${currentUser}`)
    ) {
      return false;
    }
    if (
      snackbar.persistencyType === 'persistent' &&
      closedPersistentSnackbars.includes(`${snackbar.id}-${currentUser}`)
    ) {
      return false;
    }
    return true;
  });

  return (
    <div>
      {visibleSnackbars.map((snackbar, index) => (
        <Snackbar
          key={snackbar.id}
          snackbarNumber={index}
          snackbar={snackbar}
          onCloseSnackbar={(id) =>
            dispatch(removeSnackbar({ id, currentUser }))
          }
        />
      ))}
    </div>
  );
}

export default SnackbarsContainer;
